import React, { useState, useEffect } from "react";
import { Button, Row, Col, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import StepperComponent from "../Stepper/Stepper";
import "./PageEnd.css";
import moment from "moment";
import QRCode from "qrcode.react";
import ServiceMesRdv from "../MesRdv/ServiceMesRdv/ServiceMesRdv";
//Print data
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../../image/logo2.png";
import Navbar from "../Navbar/Navbar";

const PageEnd = (props) => {
  useEffect(() => {
    handleNext();
    GetDataMesRdv();
  }, []);
  const [activeStep, setActiveStep] = useState(0);

  const [Infos, setInfo] = useState([]);

  const user = {
    id: JSON.parse(sessionStorage.getItem("user")).id,
    firstName: JSON.parse(sessionStorage.getItem("user")).firstName,
    lastName: JSON.parse(sessionStorage.getItem("user")).lastName,
    username: JSON.parse(sessionStorage.getItem("user")).username,
    cin: JSON.parse(sessionStorage.getItem("user")).cin,
  };

  const patient = {
    firstName: JSON.parse(sessionStorage.getItem("personAcharge"))[0].firstName,

    lastName: JSON.parse(sessionStorage.getItem("personAcharge"))[0].lastName,
  };

  console.log("patient====>", patient);
  const [typeC, setTaypeCs] = useState(
    JSON.parse(sessionStorage.getItem("Type")) &&
      JSON.parse(sessionStorage.getItem("Type")).type
  );

  const analyses = JSON.parse(sessionStorage.getItem("analyse"));
  // {
  //   id: JSON.parse(sessionStorage.getItem("analyse")).value,
  //   designation: JSON.parse(sessionStorage.getItem("analyse")).label,
  //   price: JSON.parse(sessionStorage.getItem("analyse")).prix,
  //   type: JSON.parse(sessionStorage.getItem("analyse")).type,
  // };

  //get labo data
  const lieux = JSON.parse(sessionStorage.getItem("lieux"));

  //  const rdvHour = JSON.parse(sessionStorage.getItem("hourRdv"));

  const date = JSON.parse(sessionStorage.getItem("DateRdv")).dateRdv;
  const handleNext = () => {
    setActiveStep(3);
  };

  const GetDataMesRdv = () => {
    ServiceMesRdv.getdatamesrdv(user.id).then((res) => {
      setInfo(res.data);
    });
  };

  const printRDV = () => {
    const input = document.getElementById("all");

    html2canvas(input).then((canvas) => {
      var imgData = canvas.toDataURL("image/png");
      var imgWidth = 210;
      var pageHeight = 350;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      var position = 30;
      var mainLogo = logo;

      var pdf = new jsPDF("p", "mm", "a4");
      //logo
      if (mainLogo) {
        pdf.addImage(mainLogo, "JPEG", 10, 3, 25, 15);
      }
      // image content
      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight + 10);
      heightLeft -= pageHeight;

      // pdf header
      pdf.setTextColor(0, 0, 0);
      pdf.text("Prise de rendez-vous en ligne", 70, 30);
      pdf.setFontSize(9);

      //pdf titile
      pdf.setProperties({
        title: "rendez-vous.pdf",
      });
      window.open(pdf.output("bloburl", "confirmation.pdf"));
    });
  };
  const qrData = `[ Nom complet : ${user.firstName} ${user.lastName}, CIN : ${user.cin}
   ]`;

  return (
    <>
      <Navbar />
      <div className="pageend container" id="data">
        <h2>Prise de rendez-vous en ligne</h2>
        <hr />
        <Alert variant="success">
          <p
            style={{
              marginBottom: "0",
              textAlign: "center",
              fontSize: "x-large",
            }}
          >
            Votre rendez-vous est bien confirmé
          </p>
        </Alert>
        <StepperComponent activeStep={activeStep} />
        <div className="all" id="all">
          <Row>
            <Col lg={9}>
              <h5>Merci de votre confiance</h5>
              <p>
                Votre rendez-vous est réservé. Votre numéro de référence est le{" "}
                <strong>{user.cin} </strong> .<br />
                <strong>
                  IMPORTANT - Vous devez présenter votre ordonnance médicale et
                  la carte d'identité au moment du rendez-vous
                </strong>
              </p>
              <p>
                Pour annuler ce rendez-vous, cliquez{" "}
                <Link style={{ color: "red" }} to="/mesrdv">
                  ici
                </Link>
                <span
                  className="ml-2"
                  style={{ fontWeight: "700", color: "#2ecc71" }}
                >
                  {lieux && lieux.tel}
                </span>
                .
              </p>
            </Col>
            <Col lg={3} />
          </Row>

          <div className="analyseInfo">
            <div className="d-inline-flex">
              <Row>
                <Col lg={5} xs={12}>
                  <div className="card1">
                    <ul className="pl-3">
                      <li>
                        Compte :
                        <strong>
                          {" "}
                          {user.firstName} {user.lastName}
                        </strong>
                      </li>
                      <li>
                        Patient :
                        <strong>
                          {" "}
                          {patient.firstName} {patient.lastName}
                        </strong>
                      </li>
                      {analyses.length > 0 && (
                        <li>
                          Services :
                          <table className="table table-striped table-bordered text-center">
                            <thead>
                              <tr>
                                <th>Préstations</th>
                                <th>Prix (Dh)</th>
                              </tr>
                            </thead>

                            {analyses.map((item) => {
                              return (
                                <tbody>
                                  <tr>
                                    <td>{item.label ? item.label : "-"}</td>

                                    <td>{item.prix ? item.prix : "-"}</td>
                                  </tr>
                                </tbody>
                              );
                            })}
                          </table>
                        </li>
                      )}
                      <li>
                        Date :{" "}
                        <strong>{`${moment(date).format(
                          "DD/MM/YYYY"
                        )}`}</strong>
                      </li>{" "}
                      <li>
                        Type : <strong> Sur place</strong>
                      </li>
                      <li>
                        Nom :{" "}
                        <strong>
                          {lieux.denomination ? lieux.denomination : "-"}
                        </strong>
                      </li>
                      <li>
                        Addresse :
                        <b>{` ${lieux.address ? lieux.address : "-"}`}</b>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col lg={4} xs={12}>
                  <div className="card2">
                    <h5>Nos services sont remboursés, n'attendez pas.</h5>
                    <p>
                      Nos services sont remboursés par la plupart des régimes
                      d'assurance collectives et privées. Renseignez-vous auprès
                      de votre assureur.
                    </p>
                  </div>
                </Col>

                <Col className="qr" lg={3} xs={12}>
                  <QRCode
                    id={`${user.cin}`}
                    value={`${qrData}`}
                    size={160}
                    level={"H"}
                    includeMargin={true}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <Row>
          <Col lg={2}>
            <p>* Prix sujet ‡ confirmation lors de votre rendez-vous</p>
          </Col>
          <Col lg={6}>
            <div className="card">
              <h4>Vous avez des questions?</h4>
              <p>
                N'hésitez pas à contacter le numéro{" "}
                <span
                  style={{
                    fontWeight: "700",
                    color: "#2ecc71",
                  }}
                >
                  {lieux && lieux.tel}
                </span>
                . Du lundi au vendredi de 9 h à 18 h et samedi de 9 h et 13 h.
              </p>
            </div>
          </Col>

          <Col className="print-btn" lg={4}>
            <button
              className="btn2 home mr-2"
              style={{
                width: "250px",
                background: typeC === "Covid" ? "#c4e538" : "#2ecc71",
              }}
              onClick={() => window.print()}
            >
              Imprimer la confirmation
            </button>
            <Link to="/">
              <button
                className="btn2 home"
                style={{
                  width: "250px",
                  background: typeC === "Covid" ? "#c4e538" : "#2ecc71",
                }}
              >
                &thinsp; &thinsp; Retourner l'accueil &thinsp; &thinsp;
              </button>
            </Link>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PageEnd;
